import React from 'react';
import { GuestSpeakerForm } from 'components/layout/forms';
import { PageWrapper2 } from 'components/modules/Wrapper2';
// import { home } from 'assets/images';
function GuestSpeakerView() {
	return (
		<div className='bg-[#0E1022]'>
			<PageWrapper2>
				<div>
					<GuestSpeakerForm />
				</div>
			</PageWrapper2>
		</div>
	);
}

export default GuestSpeakerView;
